import { io, Socket } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_WA_SOCKET_URL ?? "http://localhost:8484";

let socket: Socket | null = null;

// TODO [SECURITY]: The WA server currently accepts any non-empty token as a
// valid frontend client (server.js lines 158-162). This means socket auth is
// effectively open. To harden this in the future:
//
// Option A — Dedicated service token:
//   1. Add ADMIN_SOCKET_TOKEN env var to the WA server
//   2. Check it explicitly in the socket auth middleware (before the catch-all)
//   3. Pass it here via REACT_APP_WA_SOCKET_TOKEN
//
// Option B — Shared JWT validation:
//   1. WA server validates JWT signature using a shared secret or JWKS endpoint
//   2. Both agents frontend and admin frontend JWTs would be verified
//   3. Requires coordinating JWT_SECRET between Symfony (admin) and Express (WA)
//
// Option C — Token exchange endpoint:
//   1. Admin backend exposes GET /api/admin/whatsapp/socket-token
//   2. This calls WA server to generate a short-lived socket-only JWT
//   3. Admin frontend fetches it before connecting socket.io
//
// The same gap exists in whatsapp-automation/agents (socketService.js) which
// also passes its JWT without server-side signature verification.
export function getWhatsAppSocket(): Socket {
  if (!socket) {
    const token = localStorage.getItem("admin:token") ?? "admin";
    socket = io(SOCKET_URL, {
      auth: { token },
      path: "/socket.io",
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });
  }
  return socket;
}

export function joinConversation(conversationId: string): void {
  getWhatsAppSocket().emit("joinConversation", conversationId);
}

export function leaveConversation(conversationId: string): void {
  getWhatsAppSocket().emit("leaveConversation", conversationId);
}

export function disconnectWhatsAppSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
